import { render } from "./SingleSaleForSix.vue?vue&type=template&id=2c067a6e&scoped=true"
import script from "./SingleSaleForSix.vue?vue&type=script&lang=js"
export * from "./SingleSaleForSix.vue?vue&type=script&lang=js"

import "./SingleSaleForSix.vue?vue&type=style&index=0&id=2c067a6e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c067a6e"]])

export default __exports__